import { Backdrop, Box, Modal, Typography, IconButton } from '@mui/material';
import classes from './AcknowledgementModal.module.scss';
import { Button } from '../../Buttons';
import CloseIcon from '@src/icons/CloseIcon';
interface AcknowledgementModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  content?: string;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  primaryButtonCallback?: () => void;
  secondaryButtonCallback?: () => void;
}
const AcknowledgementModal = ({
  open,
  onClose,
  title = 'Headline',
  content = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi magna sem.',
  primaryButtonText = 'Schedule anyway',
  secondaryButtonText = 'Find a different location',
  primaryButtonCallback,
  secondaryButtonCallback
}: AcknowledgementModalProps) => {
  // Dismisses the modal without navigating away, leaving the patient where they are
  const handleCloseButtonClick = () => {
    onClose();
  };
  const handlePrimaryButtonClick = () => {
    onClose();
    if (primaryButtonCallback) {
      primaryButtonCallback();
    }
  };
  const handleSecondaryButtonClick = () => {
    onClose();
    if (secondaryButtonCallback) {
      secondaryButtonCallback();
    }
  };
  return <div data-sentry-component="AcknowledgementModal" data-sentry-source-file="AcknowledgementModal.tsx">
			<Modal open={open} onClose={onClose} closeAfterTransition slots={{
      backdrop: Backdrop
    }} slotProps={{
      backdrop: {
        timeout: 500
      }
    }} data-sentry-element="Modal" data-sentry-source-file="AcknowledgementModal.tsx">
				<Box className={classes['simple-modal-container-style']} data-sentry-element="Box" data-sentry-source-file="AcknowledgementModal.tsx">
					<Box className={classes['simple-modal-header-style']} data-sentry-element="Box" data-sentry-source-file="AcknowledgementModal.tsx">
						<IconButton className={classes['simple-modal-close-button-style']} aria-label="Close acknowledgement" onClick={handleCloseButtonClick} data-sentry-element="IconButton" data-sentry-source-file="AcknowledgementModal.tsx">
							<CloseIcon data-sentry-element="CloseIcon" data-sentry-source-file="AcknowledgementModal.tsx" />
						</IconButton>
						<Typography data-testid="modal-title" variant="title" className={classes['simple-modal-header-title-style']} data-sentry-element="Typography" data-sentry-source-file="AcknowledgementModal.tsx">
							{title}
						</Typography>
					</Box>
					<Typography data-testid="modal-content" className={classes['simple-modal-content-style']} data-sentry-element="Typography" data-sentry-source-file="AcknowledgementModal.tsx">
						{content}
					</Typography>
					<Button data-testid="primary-button" className={classes['simple-modal-button-style']} onClick={handlePrimaryButtonClick} data-sentry-element="Button" data-sentry-source-file="AcknowledgementModal.tsx">
						{primaryButtonText}
					</Button>
					<Button data-testid="secondary-button" className={classes['simple-modal-button-style']} variant="secondary" onClick={handleSecondaryButtonClick} data-sentry-element="Button" data-sentry-source-file="AcknowledgementModal.tsx">
						{secondaryButtonText}
					</Button>
				</Box>
			</Modal>
		</div>;
};
export default AcknowledgementModal;